import React from 'react';

const WorkOrderStep9Completion = ({ formData, setFormData, formErrors, users }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="step-form">
      <div className="form-section">
        <h3 className="section-title">Completion & Approval</h3>
        <div className="row">
          <div className="form-group col-md-3">
            <label htmlFor="completedBy">Completed By</label>
            <select
              id="completedBy"
              name="completedBy"
              value={formData.completedBy}
              onChange={handleChange}
            >
              <option value="">Select Technician</option>
              {users.map(user => (
                <option key={user.userId} value={user.userId}>
                  {user.fullName}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group col-md-5">
            <label htmlFor="technicianSignature">Technician Signature (digital)</label>
            <input
              type="text"
              id="technicianSignature"
              name="technicianSignature"
              value={formData.technicianSignature}
              onChange={handleChange}
              placeholder="Signature or file path"
            />
            <small style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
              Note: Digital signature functionality will be implemented separately
            </small>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="verifiedBy">Verified By (Supervisor)</label>
            <select
              id="verifiedBy"
              name="verifiedBy"
              value={formData.verifiedBy}
              onChange={handleChange}
            >
              <option value="">Select Supervisor</option>
              {users.map(user => (
                <option key={user.userId} value={user.userId}>
                  {user.fullName}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="closedDate">Close Date</label>
            <input
              type="date"
              id="closedDate"
              name="closedDate"
              value={formData.closedDate}
              onChange={handleChange}
            />
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="maintenanceCode">Maintenance Code/Tag for reporting</label>
            <input
              type="text"
              id="maintenanceCode"
              name="maintenanceCode"
              value={formData.maintenanceCode}
              onChange={handleChange}
              placeholder="PM 01, BD 02, etc."
            />
            <small style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
              Use codes like PM 01 for Preventive Maintenance, BD 02 for Breakdown, etc.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderStep9Completion;

